//@author: mandy

import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { LocationSettingsComponent } from "./location.settings.component";
import { S25BreakpointModule } from "../../s25-breakpoint/s25.breakpoint.module";
import { SearchOptionsModule } from "../search-options/search.options.module";

@NgModule({
    declarations: [LocationSettingsComponent],
    imports: [CommonModule, FormsModule, S25BreakpointModule, SearchOptionsModule],
    providers: [LocationSettingsComponent],
})
export class LocationSettingsModule {
    constructor() {}
}
